"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHighlightDataFromEditorSelection = exports.highlightChanges = void 0;

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _constants = require("composer-lib/lib/constants");

var _draftJs = require("draft-js");

var highlightChanges = function highlightChanges(postData, editorState) {
  if (!postData.get('justUpdated')) {
    return _draftJs.EditorState.undo(editorState);
  }

  var changedBlocks = postData.get('changedBlocks');
  var contentState = editorState.getCurrentContent();

  for (var i = 0; i < changedBlocks.length; i++) {
    var blockKey = changedBlocks[i];
    var block = editorState.getCurrentContent().getBlockForKey(blockKey);

    if (!block) {
      continue;
    }

    var selectionState = _draftJs.SelectionState.createEmpty(blockKey).set('focusOffset', block.getLength());

    var contentStateWithEntity = contentState.createEntity(_constants.CHANGE_ENTITY_TYPE, 'IMMUTABLE', {});
    contentState = _draftJs.Modifier.applyEntity(contentStateWithEntity, selectionState, contentStateWithEntity.getLastCreatedEntityKey());
  } // do it as one big change so we can just run `undo` to get rid of it


  return _draftJs.EditorState.push(editorState, contentState, _constants.CHANGE_EDITOR_CHANGE_TYPE);
};

exports.highlightChanges = highlightChanges;

var getHighlightDataFromEditorSelection = function getHighlightDataFromEditorSelection(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  var endKey = selection.getEndKey();
  var startOffset = selection.getStartOffset();
  var endOffset = selection.getEndOffset();
  var blockMap = editorState.getCurrentContent().getBlockMap();
  var blockForConversation = startKey;
  var highlightStart = startOffset;
  var highlightEnd = endOffset;

  if (startKey !== endKey) {
    if (!(0, _draftHelpers.blockKeysAreAdjacent)(editorState.getCurrentContent(), startKey, endKey)) {
      return null;
    } // This covers case where user selects the end of an extra block
    // so we want to treat it as not counting that block in this case


    var startBlockLength = blockMap.get(startKey).getLength();
    var endBlockLength = blockMap.get(endKey).getLength();

    if (selection.getIsBackward()) {
      if (startOffset === startBlockLength && endOffset >= 1 && endOffset <= endBlockLength) {
        blockForConversation = endKey;
        highlightStart = 0;
      } else {
        return null;
      }
    } else if (startOffset >= 0 && startOffset <= startBlockLength && endOffset === 0) {
      blockForConversation = startKey;
      highlightEnd = startBlockLength;
    } else {
      return null;
    }
  } else {
    var block = blockMap.get(blockForConversation);

    if (block.getType() === 'atomic') {
      return null;
    }
  }

  return {
    blockKey: blockForConversation,
    highlightStart: highlightStart,
    highlightEnd: highlightEnd
  };
};

exports.getHighlightDataFromEditorSelection = getHighlightDataFromEditorSelection;